export default __webpack_public_path__ + "static/media/notification.7e7141d1.m4a";